<template>
  <div>
    <cadastro-base :salvar="salvarModelo">
      <template slot="conteudo">
        <b-row>
          <b-form-group class="col-12 my-0 pb-0">
            <b-form-checkbox
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
              @change="inativarModelo"
            >
              <label style="font-size: 1rem">Modelo Ativo</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Descrição"
            class="col-md-12"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Descrição"
            >
              <b-form-input
                v-model="form.descricao"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Tipo"
            class="col-md-6"
          >
            <b-form-select
              v-model="form.tipoModelo"
              :options="tipoOpcoes"
              @input="alteraTipo"
            />
          </b-form-group>
          <b-col cols="6">
            <departamento-select
              v-model="form.departamento"
              :disabled="form.tipoModelo === 0"
              @input="getDocumentosPorDep"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            class="mt-3"
          >
            <h4>Seleção de Documentos</h4>
            <fieldset class="font-weight-bold text-muted small">
              Selecione os documentos que deseja vincular a este modelo.
            </fieldset>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="12">
            <b-tabs end>
              <div
                v-for="docPorDep in form.documentos"
                :key="docPorDep.departamento.id"
              >
                <b-tab :title="docPorDep.departamento.nome">
                  <tabela-documento
                    v-model="docPorDep.documentos"
                    :colunas="colunasDocumento"
                    :mostrar-selecionados="state === 'editar'"
                  />
                </b-tab>
              </div>
            </b-tabs>
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
    <div v-if="docSelecionado && docAdicionar">
      <atualizar-empresa
        v-model="docSelecionado"
        :modelo-id="$route.params.id"
        :multiplas-empresas="false"
        :adicionar="docAdicionar"
        :documentos-foram-adicionados="documentosForamAdicionados"
        :documentos-foram-removidos="documentosForamRemovidos"
        @hide="salvarModeloPosValidacao"
        @cancel="finalizarSemAtualizarDocumentosNaEmpresa"
        @show-loading="showLoading"
        @fechar-sem-atualizar="finalizarSemAtualizar"
      />
    </div>

    <!--Tela de progresso-->
    <loading
      :is-loading="isLoading"
      :cancelar-upload="cancelarProcesso"
    />
  </div>
</template>

<style lang="scss">
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { BTabs, BTab } from 'bootstrap-vue'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/documento/modelo/shared/services/api'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'Modelo',
  components: {
    CadastroBase,
    ValidationProvider,
    BTabs,
    BTab,
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    TabelaDocumento: () => import('@/shared/components/visualizacao-documento/VisualizacaoDocumento.vue'),
    AtualizarEmpresa: () => import('../atualizar-empresa/AtualizarEmpresa.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
  },
  data() {
    return {
      required,
      form: {
        descricao: '',
        tipoModelo: 0,
        departamento: null,
        ativo: true,
        documentos: [],
      },
      docsAntigos: [],
      docsNovos: [],
      documentosForamAdicionados: false,
      documentosForamRemovidos: false,
      docSelecionado: null,
      docAdicionar: false,
      immutableForm: {},
      tipoOpcoes: [{ value: 0, text: 'Recorrente' }, { value: 1, text: 'Não Recorrente' }],
      documentoPorDep: null,
      colunasDocumento: [
        { label: 'Descrição', field: 'descricao' },
      ],
      isLoading: false,
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    } else {
      this.getDocumentosPorDep()
    }
  },
  methods: {
    carregar(id) {
      api.getModelo(id)
        .then(payload => {
          this.form = payload.data
          this.form.documentos.forEach(docPorDep => {
            docPorDep.documentos.forEach(doc => {
              if (doc.selecionado) {
                this.docsAntigos.push(doc)
              }
            })
          })
        })
    },
    salvarModelo() {
      this.verificaAtualizacaoDocumentos()

      if (this.state === 'editar') {
        apiEmpresa.existeEmpresaComModelo(this.$route.params.id)
          .then(payload => {
            if (payload.data) {
              this.docAdicionar = true
              this.docSelecionado = [...this.form.documentos]
            } else {
              this.salvarModeloPosValidacao(null)
            }
          }).catch(err => {
            throw err
          })
      } else {
        this.salvarModeloPosValidacao()
      }
    },
    salvarModeloPosValidacao(empresasSelecionadas) {
      return new Promise(() => {
        if (this.state === 'novo') {
          api.createModelo(this.form)
            .then(() => {
              this.$router.go(-1)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Modelo cadastrado com sucesso',
                  text: '',
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                },
              })
            })
            .catch(err => {
              this.$handleError(err)
            })
        } else {
          this.form.empresas = empresasSelecionadas
          // eslint-disable-next-line global-require
          const axios = require('axios')
          api.updateModelo(this.form.id, this.form, axios.CancelToken)
            .then(() => {
              this.$router.go(-1)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Modelo alterado com sucesso',
                  text: '',
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                },
              })
            })
            .catch(err => {
              if (err.response === undefined) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Processo cancelado',
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                  },
                })
              } else {
                this.$handleError(err)
              }
              this.docSelecionado = null
              this.docAdicionar = false
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
    finalizarSemAtualizarDocumentosNaEmpresa() {
      this.docSelecionado = null
      this.docAdicionar = false
    },
    finalizarSemAtualizar() {
      this.docSelecionado = null
      this.docAdicionar = false
      this.salvarModeloPosValidacao(null)
    },
    getDocumentosPorDep() {
      const depId = this.form.departamento !== null ? this.form.departamento.id : 0
      api.getDocumentos(depId, this.state === 'novo')
        .then(payload => {
          const docsPorDep = payload.data
          // eslint-disable-next-line prefer-destructuring
          this.form.documentos = docsPorDep[0].filter(x => x !== null)
        })
    },
    alteraTipo(tipo) {
      if (tipo === 0) {
        this.form.departamento = null
        this.getDocumentosPorDep()
      }
    },
    verificaAtualizacaoDocumentos() {
      this.docsNovos = []
      this.form.documentos.forEach(docPorDep => {
        docPorDep.documentos.forEach(doc => {
          if (doc.selecionado) {
            this.docsNovos.push(doc)
          }
        })
      })
      this.definirSeHouveInclusaoOuRemocao(this.docsAntigos, this.docsNovos)
    },
    definirSeHouveInclusaoOuRemocao(antigos, novos) {
      const antigosDiff = []
      antigos.forEach(antigo => {
        if (!novos.includes(antigo)) {
          antigosDiff.push(antigo)
        }
      })

      this.documentosForamAdicionados = false
      this.documentosForamRemovidos = false

      if (antigosDiff.length > 0 && antigos.length === novos.length) {
        this.documentosForamAdicionados = true
        this.documentosForamRemovidos = true
      } else if (antigosDiff.length === 0 && antigos.length < novos.length) {
        this.documentosForamAdicionados = true
      } else if (antigosDiff.length > 0 && antigos.length > novos.length) {
        this.documentosForamRemovidos = true
      }
    },
    showLoading() {
      this.isLoading = true
    },
    cancelarProcesso() {
      api.cancelarEnvio()
      this.isLoading = false
    },
    inativarModelo(checked) {
      if (this.state === 'editar') {
        if (!checked) {
          this.$swal({
            title: 'Deseja realmente inativar esse modelo?',
            text: 'Atenção: essa ação inativará este modelo e seus vínculos com o cadastro de empresas.',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
            focusConfirm: false,
            icon: 'warning',
            customClass: {
              confirmButton: 'mr-1 w-25 btn-primary',
              cancelButton: 'w-25 btn-danger',
            },
          }).then(result => {
            if (!result.value) {
              this.form.ativo = !checked
            }
          })
        }
      }
    },
  },
}
</script>
